module.exports = __webpack_public_path__ + "static/img/service-QC.8b4f279.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/service-QC.png
// module id = SB6P
// module chunks = 0